<template>
  <lazy-component>
    <iframe class="video-iframe" width="100%" height="auto" :src="src"></iframe>
  </lazy-component>
</template>

<script>
export default {
  name: "app-soundcloud",
  props: {
    url: {
      type: String,
      required: true
    },
    artwork: {
      default: "false"
    },
    autoplay: {
      default: "false"
    },
    color: {
      default: "#c80004"
    }
  },
  computed: {
    src() {
      return `https://w.soundcloud.com/player/?url=${this.url}&color=${this.color}&auto_play=${this.autoplay}&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=true&visual=true`;
    }
  }
};
</script>
